
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { PortRequestFormServiceService } from '../../service/port-request-FormService/port-request-form.service.service';
import { ReportVerifyPopupComponent } from '../report-verify-popup/report-verify-popup.component';

interface Report {
  id: number;
  vesselIMO: string;
  vesselName: string;
  jsonCreatedAt: string;
  event: string;
  disabled?: boolean;
}

interface Vessel {
  vesselName: string;
  vesselIMO: string;
  reports: Report[];
  showReports?: boolean;
}

@Component({
  selector: 'app-confirm-voyage-number',
  templateUrl: './confirm-voyage-number.component.html',
  styleUrls: ['./confirm-voyage-number.component.scss']
})
export class ConfirmVoyageNumberComponent implements OnInit {

  reportTypeForm!: FormGroup;

  vessels: Vessel[] = [];
  filteredVessels: Vessel[] = [];

  selectedReport: Report | null = null;

  selectedVessel: string = '';
  selectedDateTime: string = '';
  selectedEvent: string = '';

  vesselList: string[] = [];
  eventList: string[] = ['Departure', 'Arrival', 'Loading', 'Discharge'];

  searchControl = new FormControl('');

  isLoading = false;
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private portRequestFormService: PortRequestFormServiceService,
    private router: Router,
    private dialogRef: MatDialogRef<ReportVerifyPopupComponent>
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadVessels();
  }

  initForm(): void {
    this.reportTypeForm = this.fb.group({});
  }

  loadVessels(): void {
    // this.portRequestFormService.getVesselList().subscribe({
    //   next: (res: any[]) => {
    //     this.vesselList = res.map(v => v.vesselName);
    //   },
    //   error: (err: any) => console.error(err)
    // });
  }
useMerakiVoyage: boolean | null = null;

setMerakiChoice(value: boolean) {
  this.useMerakiVoyage = value;
}


  fetchReport(): void {
    if (!this.selectedVessel || !this.selectedDateTime || !this.selectedEvent) {
      return;
    }

    const payload = {
      vesselName: this.selectedVessel,
      dateTime: this.selectedDateTime,
      event: this.selectedEvent
    };

    // this.portRequestFormService.getReportByFilters(payload).subscribe({
    //   next: (data: any) => {
    //     this.portRequestFormService.setReportData(data);
    //     this.dialogRef.close();
    //     this.router.navigate(['/pc-newForm']);
    //   },
    //   error: (err: any) => console.error(err)
    // });
  }

  applyFilter(search: string): void {
    const term = search.toLowerCase().trim();

    if (!term) {
      this.filteredVessels = [...this.vessels];
      return;
    }

    this.filteredVessels = this.vessels.filter(v =>
      v.vesselName.toLowerCase().includes(term)
    );

    this.filteredVessels.forEach(v => v.showReports = false);
    if (this.filteredVessels.length === 1) {
      this.filteredVessels[0].showReports = true;
    }
  }

  toggleDropdown(selected: Vessel): void {
    this.filteredVessels.forEach(v => {
      if (v !== selected) v.showReports = false;
    });
    selected.showReports = !selected.showReports;
  }

  onRadioChange(report: Report): void {
    if (!report.disabled) {
      this.selectedReport = report;
    }
  }

  onSubmit(): void {
    if (!this.selectedReport || this.isSubmitting) return;

    this.isSubmitting = true;

    // this.portRequestFormService
    //   .getPendingReportByIMO(this.selectedReport.vesselIMO)
    //   .subscribe({
    //     next: (data: any) => {
    //       this.isSubmitting = false;
    //       this.portRequestFormService.setReportData(data);
    //       this.dialogRef.close();
    //       this.router.navigate(['/pc-newForm']);
    //     },
    //     error: (err: any) => {
    //       this.isSubmitting = false;
    //       console.error(err);
    //     }
    //   });
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
